import { createFileRoute } from '@tanstack/react-router';
import { PartnerWizardSheet } from '@/pages/referrers/wizard/partner-wizard-sheet';

/** «Nuovo rivenditore» guidato, sopra la lista dei referrer. */
export const Route = createFileRoute(
  '/admin/_layout/referrers/_layout/new-partner'
)({
  component: () => <PartnerWizardSheet />,
});
